module.exports = __webpack_public_path__ + "img/regular_2.8390f3de.jpg";